import { Print as PrintIcon, Download as DownloadIcon } from '@mui/icons-material';
import { GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { useNotification } from '@/hooks';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { useBatchLabelPrint } from '../hooks';
import { MAX_LABELS_PER_PRINT } from '../constants/routing.constants';
import BatchLabelProgressDrawer from './BatchLabelProgressDrawer';

interface BatchLabelPrintProps {
  selectedShippings: Set<string>;
}

const BatchLabelPrint = ({ selectedShippings }: BatchLabelPrintProps) => {
  const {
    printShippings,
    isPrinting,
    downloadShippings,
    isDownloading,
    job,
    dismissJob,
  } = useBatchLabelPrint();
  const { showNotification } = useNotification();

  const getSelectedNumbers = () => {
    const numbers = Array.from(selectedShippings).map(Number);
    if (numbers.length > MAX_LABELS_PER_PRINT) {
      showNotification(
        `Se procesarán solo las primeras ${MAX_LABELS_PER_PRINT} etiquetas de las ${numbers.length} seleccionadas`,
        NotificationSeverity.warning
      );
    }
    return numbers;
  };

  const isBusy = isPrinting || isDownloading;

  return (
    <div className='flex items-center gap-2'>
      {selectedShippings.size > MAX_LABELS_PER_PRINT && (
        <span className='text-sm text-orange-600 font-semibold'>
          Límite de {MAX_LABELS_PER_PRINT} etiquetas por impresión
        </span>
      )}
      <GlobalButton
        variant={GlobalButtonVariant.secondaryButton}
        action={() => downloadShippings(getSelectedNumbers())}
        disabled={selectedShippings.size === 0 || isBusy}
      >
        <DownloadIcon />
        Descargar ({selectedShippings.size})
      </GlobalButton>
      <GlobalButton
        variant={GlobalButtonVariant.primaryButton}
        action={() => printShippings(getSelectedNumbers())}
        disabled={selectedShippings.size === 0 || isBusy}
      >
        <PrintIcon />
        Imprimir ({selectedShippings.size})
      </GlobalButton>

      <BatchLabelProgressDrawer job={job} onClose={dismissJob} />
    </div>
  );
};

export default BatchLabelPrint;
